import useAxios from '@hooks/useFetch';
import { components, paths } from '@api/api';

const BYO_FILTER_API_ENDPOINT: keyof paths = '/ByoFilter/{countryCode}';
type MainFilterOutput = components['schemas']['MainFilterOutput'];

export default function useByoFilter(countryCode: string = 'USA') {
    const endPoint = BYO_FILTER_API_ENDPOINT.replace('{countryCode}', countryCode);
    const {
        data,
        isLoading,
        error,
        doFetch,
    } = useAxios<MainFilterOutput>({
        method: 'get',
        url: endPoint,
        lazy: false,
    });

    return {
        data,
        isLoading,
        error,
        doFetch,
    };
}
